import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from '../../environments/environment';
import {AgencyInterfaceData} from '../shared/models/agency.model';



@Injectable({providedIn: 'root'})
export class AgencysService {

  url:string = `${environment['API_URL']}`

  constructor(private http: HttpClient,) {
  }

  getUserSelf(endpoint: string){
    let url = `${this.url}/${endpoint}`;
    return this.http.get(url);
  }

  getAgency(endpoint: string){
    //{ headers: headers, params: params }
    console.log('this.url',this.url)
    let url = `${this.url}/${endpoint}`;
    console.log('url',url)
    return this.http.get<AgencyInterfaceData>(url);
  } //end login

  getAgencys(endpoint: string){
    //{ headers: headers, params: params }
    console.log('this.url',this.url)
    let url = `${this.url}/${endpoint}`;
    console.log('url',url)
    return this.http.get<AgencyInterfaceData[]>(url);
  } //end login

  patchAgency(endpoint: string, data){
    //{ headers: headers, params: params }
    let url = `${this.url}/${endpoint}`;
    return this.http.patch(url,data,{observe: 'response'});
  } //end login


} //
